import { motion } from 'framer-motion'
import { pipelineItems } from '@/components/home/home-data'
import { blockCard } from '@/lib/ui-classes'

export function CreationPipeline() {
  return (
    <section id="workflow" className="relative bg-black px-4 py-24 sm:px-6">
      <div className="absolute right-0 top-24 h-72 w-72 rounded-full bg-[#C1FAB8]/8 blur-3xl" />

      <div className="mx-auto max-w-6xl">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="mx-auto mb-16 max-w-3xl text-center"
        >
          <h2 className="text-3xl font-semibold text-white md:text-5xl">创作流程一目了然</h2>
          <p className="mt-6 text-lg leading-8 text-zinc-400">
            按系统真实生产链路组织首页内容，帮助新用户快速理解如何把一个故事做成完整漫剧。
          </p>
        </motion.div>

        <div className="relative">
          <div className="absolute bottom-0 left-[1.6rem] top-0 hidden w-px bg-gradient-to-b from-transparent via-[#07F4F2]/35 to-transparent md:block" />

          <div className="space-y-5">
            {pipelineItems.map(({ step, title, desc, icon: Icon }) => (
              <motion.div
                key={step}
                initial={{ opacity: 0, y: 24 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: '-80px' }}
                transition={{ duration: 0.45 }}
                className="relative grid grid-cols-1 gap-4 md:grid-cols-[72px_1fr]"
              >
                <div className="relative hidden md:flex items-start justify-center">
                  <div className="z-10 flex h-14 w-14 items-center justify-center rounded-full border border-[#07F4F2]/25 bg-black shadow-[0_0_24px_rgba(7,244,242,0.18)]">
                    <Icon className="h-6 w-6 text-[#07F4F2]" />
                  </div>
                </div>

                <div className={`${blockCard} rounded-3xl border-l border-l-[#07F4F2]/20 p-6 md:border-l md:border-white/10`}>
                  <div className="flex flex-wrap items-center gap-4">
                    <span className="text-4xl font-black tracking-tight text-[#07F4F2]/20">{step}</span>
                    <div className="flex h-11 w-11 items-center justify-center rounded-2xl border border-[#07F4F2]/20 bg-[#07F4F2]/10 md:hidden">
                      <Icon className="h-5 w-5 text-[#07F4F2]" />
                    </div>
                    <h3 className="text-2xl font-semibold text-white">{title}</h3>
                  </div>
                  <p className="mt-4 text-base leading-7 text-zinc-400">{desc}</p>
                </div>
              </motion.div>
            ))}
          </div>
        </div>
      </div>
    </section>
  )
}
